import { Link } from "react-router-dom";
import { waLink } from "@/data/site";
import { MessageCircle, Calendar } from "lucide-react";

const base =
  "inline-flex items-center justify-center gap-2 rounded-full font-sans font-600 transition-transform duration-300 will-change-transform active:scale-[0.98]";

const sizes = {
  md: "px-6 py-3 text-sm",
  lg: "px-8 py-4 text-base",
};

/** Gold primary CTA -> Book a free briefing (links to /contact by default). */
export const GoldButton = ({ to = "/contact", children = "Book a free briefing", size = "md", testid, icon = true, className = "" }) => (
  <Link
    to={to}
    data-testid={testid || "book-briefing-btn"}
    className={`${base} ${sizes[size]} bg-gold text-navy-dark hover:-translate-y-0.5 shadow-soft ${className}`}
  >
    {icon && <Calendar className="h-4 w-4" strokeWidth={2.2} />}
    {children}
  </Link>
);

/** WhatsApp outline/solid CTA. */
export const WhatsAppButton = ({ text, children = "Message us on WhatsApp", size = "md", variant = "outline", testid, className = "" }) => {
  const styles =
    variant === "solid"
      ? "bg-[#25D366] text-white hover:-translate-y-0.5"
      : "border border-white/40 text-white hover:bg-white/10";
  return (
    <a
      href={waLink(text)}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testid || "whatsapp-cta-btn"}
      className={`${base} ${sizes[size]} ${styles} ${className}`}
    >
      <MessageCircle className="h-4 w-4" strokeWidth={2.2} />
      {children}
    </a>
  );
};

/** WhatsApp button styled for light backgrounds. */
export const WhatsAppButtonLight = ({ text, children = "Message us on WhatsApp", size = "md", testid, className = "" }) => (
  <a
    href={waLink(text)}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testid || "whatsapp-cta-btn"}
    className={`${base} ${sizes[size]} border border-navy/25 text-navy hover:bg-navy hover:text-white ${className}`}
  >
    <MessageCircle className="h-4 w-4" strokeWidth={2.2} />
    {children}
  </a>
);
